import ApiClient from './ApiClient';
/* global axios */

class AgentBotFunctionsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  getFunctions(botId) {
    return axios.get(`${this.url}/${botId}/functions`);
  }

  createFunction(botId, data) {
    return axios.post(`${this.url}/${botId}/functions`, { function: data });
  }

  updateFunction(botId, functionId, data) {
    return axios.patch(`${this.url}/${botId}/functions/${functionId}`, {
      function: data,
    });
  }

  deleteFunction(botId, functionId) {
    return axios.delete(`${this.url}/${botId}/functions/${functionId}`);
  }
}

export default new AgentBotFunctionsAPI();
